// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__10eaJ","inputWrap":"styles_inputWrap__3bLa6","input":"styles_input__36JJO"};